import { FC } from 'react';

import { PaymentsShell } from '../shared/payments-shell';
import { PracticePortalFrame } from '../shared/practice-portal-frame';

export const PaymentReport: FC = () => (
  <PaymentsShell title="Payment Report">
    <PracticePortalFrame path="/Payments/PaymentReconciliationDetailReport?theme=modern" title="Payment Report" />
  </PaymentsShell>
);
